var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "page-card page-card--white" },
    [
      _c(
        "v-content-section",
        {
          ref: "visual",
          staticClass: "page-card__visual",
          attrs: { content: _vm.content, variant: "white" }
        },
        [
          _c("v-icon", {
            ref: "card",
            staticClass: "content-section__card",
            attrs: { name: "symbols/cards/white" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "carousel", staticClass: "carousel carousel--white" },
        [
          _c("div", { staticClass: "carousel__absolute" }, [
            _c(
              "div",
              {
                ref: "background",
                class: [
                  "carousel__background",
                  { "carousel__background--sticky": !_vm.isIE }
                ]
              },
              _vm._l(_vm.backgrounds, function(key, keyIndex) {
                var _obj
                return _c("div", {
                  class:
                    ((_obj = {}),
                    (_obj[
                      "carousel__background-item carousel__background--" + key
                    ] = true),
                    (_obj["carousel__background--" + key + "-active"] =
                      _vm.currentSlide === keyIndex),
                    _obj)
                })
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "carousel__row", attrs: { varaint: "flex" } },
            [
              _c("v-column", { attrs: { large: 12 } }, [
                _c(
                  "div",
                  { staticClass: "carousel__wrapper carousel__wrapper--white" },
                  [
                    _c(
                      "div",
                      { ref: "sticky", staticClass: "carousel__left" },
                      [
                        _c(
                          "div",
                          {
                            class: [
                              "carousel__sticky",
                              { "carousel__sticky--active": !_vm.isIE }
                            ]
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "carousel__sticky-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "animationWrapper",
                                    class: [
                                      "carousel__image-wrapper",
                                      "carousel__image-wrapper--" +
                                        _vm.currentSlide
                                    ]
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        ref: "carouselAccount",
                                        staticClass:
                                          "carousel__visual carousel__visual--svg"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            alt: _vm.$t(
                                              "cards.white.carousel.account.alt"
                                            ),
                                            "aspect-ratio": 333 / 540,
                                            tiny: {
                                              default: require("@/images/white/carousel/account.png"),
                                              retina: require("@/images/white/carousel/account@2.png")
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              id:
                                                "fb3aa81c-b44d-4d02-8c34-5313328a5dc3",
                                              viewBox: "0 0 320.01 538.65",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id:
                                                    "b9495295-a91d-4e04-b0f2-c90dc1e8b724",
                                                  "data-name": "download"
                                                }
                                              },
                                              [
                                                _c("circle", {
                                                  attrs: {
                                                    cx: "40.5",
                                                    cy: "40.5",
                                                    fill: "#fff",
                                                    r: "40",
                                                    stroke: "#000",
                                                    "stroke-miterlimit": "10"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M34.35,22.5h12.3A4.47,4.47,0,0,1,51.12,27V56a4.47,4.47,0,0,1-4.47,4.47H34.35A4.47,4.47,0,0,1,29.88,56V27A4.47,4.47,0,0,1,34.35,22.5Zm3.91,32.41h4.47a.56.56,0,0,1,.56.56h0a.56.56,0,0,1-.56.56H38.26a.56.56,0,0,1-.56-.56h0a.56.56,0,0,1,.56-.56Zm-3.91-15.4L40.47,46l6.18-6.42-3.83,0V31.44H38.24v8.07Z",
                                                    fill: "none",
                                                    stroke: "#231f20",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id:
                                                    "a2374f3c-53ad-42c5-9e79-1c8ebc60c370",
                                                  "data-name": "edit"
                                                }
                                              },
                                              [
                                                _c("circle", {
                                                  attrs: {
                                                    cx: "279.51",
                                                    cy: "156.54",
                                                    fill: "#fff",
                                                    r: "40",
                                                    stroke: "#000",
                                                    "stroke-miterlimit": "10"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M288.78,161.83h0v8.47a4.24,4.24,0,0,1-4.24,4.24H272.9a4.24,4.24,0,0,1-4.24-4.24V142.78a4.24,4.24,0,0,1,4.24-4.24h11.64m-7.94,30.71h4.24a.53.53,0,0,1,.53.53h0a.52.52,0,0,1-.52.52H276.6a.51.51,0,0,1-.53-.51h0A.53.53,0,0,1,276.6,169.25Zm8.06-12.71-6.3,1.8,1.8-6.3,10.77-10.76a3.18,3.18,0,0,1,4.5,4.5Zm4.92-13.91,4.5,4.5m-13.92,4.92,4.5,4.5",
                                                    fill: "none",
                                                    stroke: "#231f20",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id:
                                                    "f4e418f8-d4e3-48ed-bd90-16e6412441af",
                                                  "data-name": "user"
                                                }
                                              },
                                              [
                                                _c("circle", {
                                                  attrs: {
                                                    cx: "40.24",
                                                    cy: "433.79",
                                                    fill: "#fff",
                                                    r: "40",
                                                    stroke: "#000",
                                                    "stroke-miterlimit": "10"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d:
                                                      "M50.59,435.42a8.1,8.1,0,1,1-8.1,8.1A8.11,8.11,0,0,1,50.59,435.42Zm4,6.4-4.7,4.7-2.9-2.8m-21.2,1.2a7.94,7.94,0,0,1,7.9-8h7.5m2.8-18.8a7.58,7.58,0,0,1,.21,10.7L44,429a7.7,7.7,0,0,1-10.89-10.9,7.9,7.9,0,0,1,10.89,0",
                                                    fill: "none",
                                                    stroke: "#231f20",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        ref: "carouselEurope",
                                        staticClass: "carousel__visual"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            alt: _vm.$t(
                                              "cards.white.carousel.account.alt"
                                            ),
                                            "aspect-ratio": 712 / 712,
                                            tiny: {
                                              default: require("@/images/white/carousel/europe.png"),
                                              retina: require("@/images/white/carousel/europe@2.png")
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              id:
                                                "aa09222d-0612-4c8c-a3d2-38935b77169b",
                                              "data-name":
                                                "b585005f-f960-46ec-a5df-3c792897de07",
                                              viewBox: "0 0 710.61 712.39",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              "xmlns:xlink":
                                                "http://www.w3.org/1999/xlink"
                                            }
                                          },
                                          [
                                            _c(
                                              "defs",
                                              [
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "f3ada2ee-8d89-49f4-acb2-295fd8685195",
                                                      gradientTransform:
                                                        "translate(-114.05 369.9) rotate(-47.03)",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                      x1: "303.66",
                                                      x2: "303.66",
                                                      y1: "397.36",
                                                      y2: "394.78"
                                                    }
                                                  },
                                                  [
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0",
                                                        "stop-color": "#6d6e71"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.28",
                                                        "stop-color": "#f6f6f6"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.29",
                                                        "stop-color": "#e5e6e6"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.34",
                                                        "stop-color": "#c0c1c3"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.38",
                                                        "stop-color": "#a3a5a7"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.43",
                                                        "stop-color": "#8f9093"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.47",
                                                        "stop-color": "#828487"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.52",
                                                        "stop-color": "#7e8083"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.54",
                                                        "stop-color": "#86888b"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.59",
                                                        "stop-color": "#9b9d9f"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.64",
                                                        "stop-color": "#bebfc1"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.7",
                                                        "stop-color": "#efefef"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.72",
                                                        "stop-color": "#fff"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "1",
                                                        "stop-color": "#5a5b5d"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "fd45be08-0532-4df6-9430-fd5ec28854df",
                                                      gradientTransform:
                                                        "matrix(70.71, -75.92, 22.33, 20.8, 52394.8, -68049.76)",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                      x1: "-824.24",
                                                      x2: "-824.36",
                                                      y1: "281.99",
                                                      y2: "281.97"
                                                    }
                                                  },
                                                  [
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0",
                                                        "stop-color": "#fff"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.13",
                                                        "stop-color": "#fbfbfb"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.26",
                                                        "stop-color": "#efefef"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.38",
                                                        "stop-color": "#dcdcdc"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.5",
                                                        "stop-color": "silver"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.63",
                                                        "stop-color": "#9d9d9d"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.75",
                                                        "stop-color": "#717171"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.87",
                                                        "stop-color": "#3e3e3e"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "0.99",
                                                        "stop-color": "#030303"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: { offset: "1" }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("linearGradient", {
                                                  attrs: {
                                                    id:
                                                      "f07f3953-184e-435a-848a-c40a7437d639",
                                                    gradientTransform:
                                                      "matrix(0.68, -0.73, -0.73, -0.68, 408.41, 856.55)",
                                                    x1: "638.58",
                                                    x2: "651.58",
                                                    "xlink:href":
                                                      "#fd45be08-0532-4df6-9430-fd5ec28854df",
                                                    y1: "406.42",
                                                    y2: "410.03"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("linearGradient", {
                                                  attrs: {
                                                    id:
                                                      "fa6a8c68-a8ac-405a-871c-8ee28576eeb6",
                                                    gradientTransform:
                                                      "translate(6610.13 -8840.88) rotate(-47.03) scale(14.43 4.24)",
                                                    x1: "-762.62",
                                                    x2: "-762.74",
                                                    "xlink:href":
                                                      "#fd45be08-0532-4df6-9430-fd5ec28854df",
                                                    y1: "412.02",
                                                    y2: "412"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("linearGradient", {
                                                  attrs: {
                                                    id:
                                                      "e30f92aa-92fd-4e8e-90d8-f1b6d0fddb54",
                                                    gradientTransform:
                                                      "matrix(14.89, -15.99, 14.31, 13.32, 7884.09, -16109.43)",
                                                    x1: "-784.84",
                                                    x2: "-784.75",
                                                    "xlink:href":
                                                      "#fd45be08-0532-4df6-9430-fd5ec28854df",
                                                    y1: "295.8",
                                                    y2: "295.84"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                id:
                                                  "b728534b-2d3e-4e75-81c3-1437a7d27bd4",
                                                d:
                                                  "M420.29,211.12q-25.79,56.4-93.5,91.06t-85.5,97",
                                                "data-name":
                                                  "af5a17c0-911c-4fc1-b2a3-be645fab5055",
                                                fill: "none",
                                                stroke: "#000",
                                                "stroke-dasharray": "0 6",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                id:
                                                  "b6c51471-709a-47ff-bc1a-ede85aad618e",
                                                d:
                                                  "M420.29,211.24q61.21,127.33-27.33,202T374.64,571",
                                                "data-name":
                                                  "be9fc496-550c-439c-af9b-a74795931db6",
                                                fill: "none",
                                                stroke: "#000",
                                                "stroke-dasharray": "0 6",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                id:
                                                  "a80f8744-ea52-4adc-aa85-1d0368951972",
                                                d:
                                                  "M420.29,211.24q61.21,127.33-27.33,202",
                                                "data-name":
                                                  "bac68456-0109-432c-8bc4-bde5f7deb414",
                                                fill: "none",
                                                stroke: "#000",
                                                "stroke-dasharray": "0 6",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("circle", {
                                              attrs: {
                                                id:
                                                  "b01a0f1a-76b8-4eda-9e9c-05b22294badb",
                                                cx: "223.29",
                                                cy: "446.24",
                                                "data-name":
                                                  "e4732370-5c90-4fa3-83a5-df77971e596c",
                                                fill: "none",
                                                r: "30",
                                                stroke: "#000",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("circle", {
                                              staticStyle: {
                                                isolation: "isolate"
                                              },
                                              attrs: {
                                                id:
                                                  "b62c90a9-1760-45ed-bd0c-fb93ba319014",
                                                cx: "223.29",
                                                cy: "446.24",
                                                "data-name":
                                                  "e8fa6bbd-d829-4f16-a843-3d4aae108300",
                                                fill: "none",
                                                opacity: "0.25",
                                                r: "40",
                                                stroke: "#000",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                transform:
                                                  "translate(-252.96 595.17) rotate(-80.78)"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "text",
                                              {
                                                staticStyle: {
                                                  isolation: "isolate"
                                                },
                                                attrs: {
                                                  "font-family": "Helvetica",
                                                  "font-size": "16",
                                                  "letter-spacing": "-0.03em",
                                                  transform:
                                                    "translate(204.99 448.24)"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "€150\n\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("circle", {
                                              attrs: {
                                                id:
                                                  "af5ea5d2-0a3a-4958-959a-e7318e5a39a6",
                                                cx: "420.29",
                                                cy: "161.24",
                                                "data-name":
                                                  "a09dbdea-c53c-4272-aa5a-340f89044e7b",
                                                fill: "none",
                                                r: "30",
                                                stroke: "#000",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("circle", {
                                              staticStyle: {
                                                isolation: "isolate"
                                              },
                                              attrs: {
                                                id:
                                                  "fd9f5bdd-eb6e-4803-b318-f6039a7d7937",
                                                cx: "420.29",
                                                cy: "161.24",
                                                "data-name":
                                                  "b59138cc-f37f-416e-8c0a-0b1f56d56f7c",
                                                fill: "none",
                                                opacity: "0.25",
                                                r: "40",
                                                stroke: "#000",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id:
                                                    "bd5e53d8-94a3-4a4f-aa65-61807d843ccd",
                                                  "data-name":
                                                    "e68ecf2f-9f68-4bbf-b430-2234f6934c15"
                                                }
                                              },
                                              [
                                                _c(
                                                  "text",
                                                  {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      "font-family":
                                                        "Helvetica",
                                                      "font-size": "16",
                                                      "letter-spacing":
                                                        "-0.03em",
                                                      transform:
                                                        "translate(401.99 163.24)"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "€280\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "text",
                                                  {
                                                    staticStyle: {
                                                      isolation: "isolate"
                                                    },
                                                    attrs: {
                                                      fill: "none",
                                                      "font-family":
                                                        "Helvetica",
                                                      "font-size": "16",
                                                      "letter-spacing":
                                                        "-0.03em",
                                                      stroke: "#000",
                                                      "stroke-miterlimit": "10",
                                                      transform:
                                                        "translate(401.99 163.24)"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t€280\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("circle", {
                                              attrs: {
                                                id:
                                                  "a9dde2fb-032f-426e-933b-59e05b7b3176",
                                                cx: "383.29",
                                                cy: "584.24",
                                                "data-name":
                                                  "b1cea1c1-d02b-4237-87c4-73693122a9fa",
                                                fill: "none",
                                                r: "6",
                                                stroke: "#000",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "0.5"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("circle", {
                                              attrs: {
                                                id:
                                                  "b03e9ef0-3633-4c16-9ea3-067b94890b0d",
                                                cx: "383.29",
                                                cy: "584.24",
                                                "data-name":
                                                  "eec1de9e-deb2-4ce6-bf31-32ff869feba3",
                                                r: "3"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("circle", {
                                              staticStyle: {
                                                isolation: "isolate"
                                              },
                                              attrs: {
                                                id:
                                                  "b579146d-c6f1-40fc-92e7-6209c91d42b9",
                                                cx: "383.29",
                                                cy: "584.24",
                                                "data-name":
                                                  "b62682f1-9e9a-4ae8-aa2e-2fbbaab3b1a5",
                                                fill: "none",
                                                opacity: "0.25",
                                                r: "11",
                                                stroke: "#000",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "0.5"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("circle", {
                                              staticStyle: {
                                                isolation: "isolate"
                                              },
                                              attrs: {
                                                id:
                                                  "ab0a2e05-6a6a-4c0b-ba79-3eb9abbfc6c9",
                                                cx: "383.29",
                                                cy: "584.24",
                                                "data-name":
                                                  "ee995a49-3114-4326-ad6f-50f7e187b64f",
                                                fill: "none",
                                                opacity: "0.1",
                                                r: "16",
                                                stroke: "#000",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "0.5"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id:
                                                    "bc7ef4d2-5949-4182-acd4-6fb9331a0d10",
                                                  "data-name": "Vrstva 2"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "b2ad7846-67cc-4cc7-90b2-db45dd069c93",
                                                      "data-name":
                                                        "a97f8ca2-930f-4389-baf9-9b7f49c18bc0"
                                                    }
                                                  },
                                                  [
                                                    _c("rect", {
                                                      attrs: {
                                                        id:
                                                          "a2b873de-af91-4f46-9676-4ec6c4c4f053",
                                                        "data-name":
                                                          "b9b63ae0-28a0-4212-b736-0343eeb8f222",
                                                        fill: "#222226",
                                                        height: "34.08",
                                                        rx: "4.02",
                                                        transform:
                                                          "translate(-170.73 420.14) rotate(-47.03)",
                                                        width: "52",
                                                        x: "371.39",
                                                        y: "389.2"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          id:
                                                            "e62fd6a8-a396-40f5-8b39-15b7ff027e58",
                                                          "data-name":
                                                            "fef57576-7b89-4e63-94ad-e1d6bb27d042"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "a396b7d4-3d74-41d9-8ca2-4cfa7c3a2cce",
                                                            d:
                                                              "M387,425.75a12.66,12.66,0,0,1,16.85-1.49l-.09.1a12.49,12.49,0,0,0-19.15,5.45l-.11-.1A12.72,12.72,0,0,1,387,425.75Zm-.76-.71a13.7,13.7,0,0,1,18.33-1.55l-.09.1a13.59,13.59,0,0,0-20.69,5.46l-.11-.1a13.56,13.56,0,0,1,2.56-3.91Zm-.77-.72a14.77,14.77,0,0,1,19.82-1.6l-.1.1a14.59,14.59,0,0,0-20.48,2.61,14.43,14.43,0,0,0-1.73,2.86l-.11-.1a15.1,15.1,0,0,1,2.6-3.87Zm-.76-.71a15.81,15.81,0,0,1,21.3-1.67l-.1.11a15.65,15.65,0,0,0-22,2.67,15.89,15.89,0,0,0-1.77,2.82l-.1-.09A15.53,15.53,0,0,1,384.72,423.61Zm-.77-.71a16.85,16.85,0,0,1,22.78-1.72l-.1.1A16.71,16.71,0,0,0,383.17,424a17.66,17.66,0,0,0-1.79,2.79l-.1-.09A16.86,16.86,0,0,1,384,422.9Zm-.76-.72a17.9,17.9,0,0,1,24.26-1.77l-.1.1a17.75,17.75,0,0,0-24.94,2.78,18.12,18.12,0,0,0-1.82,2.77l-.11-.1A18,18,0,0,1,383.19,422.18Zm-.76-.7a18.94,18.94,0,0,1,25.72-1.83l-.09.1a18.81,18.81,0,0,0-26.45,2.88,19.57,19.57,0,0,0-1.81,2.7l-.1-.1A18.65,18.65,0,0,1,382.43,421.48Zm-.78-.72a20,20,0,0,1,27.23-1.89l-.09.1a19.87,19.87,0,0,0-28,2.94,20.44,20.44,0,0,0-1.83,2.68l-.1-.09A20.2,20.2,0,0,1,381.65,420.76Zm-.76-.71a21,21,0,0,1,28.7-1.94l-.09.1a20.89,20.89,0,0,0-29.4,2.94,21.11,21.11,0,0,0-1.88,2.71l-.1-.1A20.48,20.48,0,0,1,380.89,420.05Zm-.77-.72a22.09,22.09,0,0,1,30.19-2l-.1.1a21.93,21.93,0,0,0-30.88,3,22.82,22.82,0,0,0-1.89,2.69l-.1-.1a21.29,21.29,0,0,1,2.79-3.69Zm-.76-.71A23.14,23.14,0,0,1,411,416.57l-.1.1a23,23,0,0,0-34.26,5.74l-.12-.11A22.82,22.82,0,0,1,379.36,418.62Zm-.77-.72a24.19,24.19,0,0,1,33.15-2.1l-.09.1a24,24,0,0,0-35.77,5.77l-.11-.1A24.5,24.5,0,0,1,378.59,417.9Zm-.77-.72A25.23,25.23,0,0,1,412.46,415l-.1.11A25.09,25.09,0,0,0,377,418.28a25.49,25.49,0,0,0-1.94,2.66l-.1-.1A25.55,25.55,0,0,1,377.82,417.18Zm-.79-.73a26.31,26.31,0,0,1,36.17-2.22l-.09.1a26.19,26.19,0,0,0-36.88,3.22,28.08,28.08,0,0,0-2,2.64l-.1-.1A25.68,25.68,0,0,1,377,416.45Zm-.77-.72a27.39,27.39,0,0,1,37.66-2.27l-.1.1a27.22,27.22,0,0,0-38.35,3.27,27.6,27.6,0,0,0-2,2.63l-.11-.09A27.94,27.94,0,0,1,376.26,415.73Zm-.77-.71a28.42,28.42,0,0,1,39.14-2.32l-.09.1a28.26,28.26,0,0,0-39.84,3.32,27.58,27.58,0,0,0-2,2.62l-.1-.09A27.84,27.84,0,0,1,375.49,415Zm-.76-.71a29.46,29.46,0,0,1,40.62-2.38l-.1.11A29.29,29.29,0,0,0,372,418l-.11-.1A30.39,30.39,0,0,1,374.73,414.31Zm-.77-.72a30.53,30.53,0,0,1,42.1-2.43l-.09.1a30.36,30.36,0,0,0-44.79,6l-.1-.1A31.22,31.22,0,0,1,374,413.59Zm-.79-.73a31.59,31.59,0,0,1,43.63-2.49l-.09.1a31.45,31.45,0,0,0-46.33,6.08l-.11-.1A32.28,32.28,0,0,1,373.17,412.86Zm-.77-.72a32.67,32.67,0,0,1,45.12-2.54l-.1.1a32.5,32.5,0,0,0-44.91,2.54,32.11,32.11,0,0,0-2.85,3.51l-.08-.13A33.5,33.5,0,0,1,372.4,412.14Zm-.79-.74a33.75,33.75,0,0,1,46.65-2.6l-.09.09a33.6,33.6,0,0,0-49,5.74l-.05-.17A33.67,33.67,0,0,1,371.61,411.4Z",
                                                            "data-name":
                                                              "a838be79-ed0c-4fb9-9bd7-18b81be597c8",
                                                            fill: "#302e2f"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "aa439740-5acf-4421-9611-a77adc03e00c",
                                                            d:
                                                              "M419.39,391.2l.25.23a23.69,23.69,0,0,1-32.64.95l.07-.07A23.62,23.62,0,0,0,419.39,391.2Zm-.55-.51.07.07a22.93,22.93,0,0,1-31.38,1.06l.06-.06a22.86,22.86,0,0,0,31.25-1.07Zm-.54-.5.07.07a22.2,22.2,0,0,1-30.34,1l.06-.07A22.13,22.13,0,0,0,418.3,390.19Zm-.55-.52.06.07a21.42,21.42,0,0,1-29.26,1l.07-.07a21.35,21.35,0,0,0,29.13-1Zm-.55-.5.23.21a20.69,20.69,0,0,1-28.38.81l.07-.08A20.62,20.62,0,0,0,417.2,389.17Zm-.53-.5.22.21a20,20,0,0,1-27.34.77l.07-.08A19.89,19.89,0,0,0,416.67,388.67Zm-.54-.51.22.21a19.21,19.21,0,0,1-26.3.74l.07-.07A19.14,19.14,0,0,0,416.13,388.16Zm-.54-.5.07.07a18.49,18.49,0,0,1-25.1.84l.06-.07A18.41,18.41,0,0,0,415.59,387.66Zm-.56-.52.21.2a17.72,17.72,0,0,1-24.16.67l.07-.08A17.63,17.63,0,0,0,415,387.14Zm-.54-.5.21.2a17,17,0,0,1-23.12.64l.07-.09A16.92,16.92,0,0,0,414.49,386.64Zm-.54-.51.21.2a16.25,16.25,0,0,1-22.08.6l.08-.08a16.15,16.15,0,0,0,21.78-.72Zm-.54-.5.21.2a15.54,15.54,0,0,1-21,.56l.08-.07A15.43,15.43,0,0,0,413.41,385.63Zm-.54-.5.2.19a14.77,14.77,0,0,1-20,.53l.07-.08a14.68,14.68,0,0,0,19.71-.64Zm-.54-.5.2.19a14,14,0,0,1-18.94.49l.07-.07A14,14,0,0,0,412.33,384.63Zm-.54-.5.2.18a13.3,13.3,0,0,1-17.9.46l.07-.07A13.24,13.24,0,0,0,411.79,384.13ZM401.54,387a12.57,12.57,0,0,0,9.67-3.42l.05.05a12.43,12.43,0,0,1-9.87,3.36h.15Zm9.17-3.88.24.22a11.81,11.81,0,0,1-15.85.36l.07-.09A11.74,11.74,0,0,0,410.71,383.12Zm-.54-.5.19.17a11.1,11.1,0,0,1-14.76.36l.07-.08A11,11,0,0,0,410.17,382.62Zm-.54-.5.08.06a10.36,10.36,0,0,1-13.6.43l.07-.08A10.26,10.26,0,0,0,409.63,382.12Zm-.54-.51.07.07a9.62,9.62,0,0,1-12.55.39l.07-.07A9.55,9.55,0,0,0,409.09,381.61Zm-.54-.5.18.16a8.88,8.88,0,0,1-11.62.26l.08-.08A8.8,8.8,0,0,0,408.55,381.11Zm-7.2,5.87a12.48,12.48,0,0,1-6.74-2.76l.06-.06A12.4,12.4,0,0,0,401.2,387l.16,0Z",
                                                            "data-name":
                                                              "b8c1282e-de5e-45c4-acd2-afdad38041a0",
                                                            fill: "#231f20"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "a1b83db5-0a5d-4098-8582-a8f1ed6a6caf",
                                                            d:
                                                              "M406.66,414a7.88,7.88,0,0,1,6.74.1l0,0a7.83,7.83,0,0,0-10.2,11l-.06,0A7.89,7.89,0,0,1,406,414.31c.23-.13.46-.25.7-.36Zm-2.14,2.12a7.42,7.42,0,0,1,8.55-1.67l0,0a7.37,7.37,0,0,0-9.8,9.74c.08.17.17.34.26.5l0,0a7.43,7.43,0,0,1,1.07-8.65Zm2.54-1.27a6.94,6.94,0,0,1,5.68,0l0,0a6.91,6.91,0,0,0-8.88,9.53l0,.05a7,7,0,0,1,2.92-9.39A3.84,3.84,0,0,1,407.06,414.8Zm-1.86,1.9a6.49,6.49,0,0,1,7.21-1.58l0,0a6.45,6.45,0,0,0-8.28,8.63s.05.11.08.17l0,0a6.5,6.5,0,0,1,1.06-7.3Zm2.24-1.06a6,6,0,0,1,4.63-.16l0,0a6,6,0,0,0-7.53,8.08l0,0a6,6,0,0,1,3-8Zm.19.42a5.59,5.59,0,0,1,4.1-.21l0,0a5.51,5.51,0,0,0-6.84,7.34l0,0A5.57,5.57,0,0,1,407.63,416.06Z",
                                                            "data-name":
                                                              "fdfdc08d-bb39-41cb-8153-ecf99e62cd4b",
                                                            fill: "#231f20"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "a4094e79-a739-4cdc-a45d-66a33ebc0a23",
                                                            d:
                                                              "M383.35,406.51a18.21,18.21,0,0,1-4.9,13.11,18.63,18.63,0,0,1-2.47,2.22l-.05,0a18.57,18.57,0,0,0,2.48-2.21,18.26,18.26,0,0,0,2.77-20.95l.05-.05A18.18,18.18,0,0,1,383.35,406.51Zm-.59-.12v.14A17.58,17.58,0,0,1,378,419.22a18.49,18.49,0,0,1-2.47,2.21l-.05-.05a17.62,17.62,0,0,0,5.26-22.29l.05-.06A17.72,17.72,0,0,1,382.76,406.39Zm-.57.16a17,17,0,0,1-4.59,12.28,16.75,16.75,0,0,1-2.48,2.2l-.05,0a16.69,16.69,0,0,0,2.49-2.19,17.1,17.1,0,0,0,2.78-19.25l.05-.06A16.9,16.9,0,0,1,382.19,406.55Zm-.59,0a16.41,16.41,0,0,1-4.43,11.85,16.2,16.2,0,0,1-2.48,2.2l-.06-.05a15.82,15.82,0,0,0,2.49-2.2A16.5,16.5,0,0,0,379.91,400l0-.06A16.26,16.26,0,0,1,381.6,406.58Zm-.57,0a15.91,15.91,0,0,1-4.27,11.45,16.29,16.29,0,0,1-2.51,2.18l0-.05a14.81,14.81,0,0,0,2.5-2.18,15.91,15.91,0,0,0,2.79-17.56l.05-.05A15.72,15.72,0,0,1,381,406.6Zm-.57,0a15.39,15.39,0,0,1-6.63,13.21l0,0a15.71,15.71,0,0,0,2.51-2.17,15.37,15.37,0,0,0,2.78-16.73l.05-.05A15.35,15.35,0,0,1,380.46,406.62Z",
                                                            "data-name":
                                                              "e0ca7f08-06a3-4ff2-bd1a-0387dcb37a42",
                                                            fill: "#231f20"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "ade31a7f-8cc2-4d60-8b5d-78a6a330e917",
                                                            d:
                                                              "M391.82,434.92a.15.15,0,0,1,.21,0,.16.16,0,0,1,0,.16.17.17,0,0,1-.14.1.15.15,0,0,1-.14-.09A.15.15,0,0,1,391.82,434.92Zm.76-.82a.15.15,0,0,1,.21,0,.16.16,0,0,1,0,.16.15.15,0,0,1-.14.1.16.16,0,0,1-.14-.08A.17.17,0,0,1,392.58,434.1Zm.76-.81a.14.14,0,0,1,.2,0,.15.15,0,0,1,0,.16.15.15,0,1,1-.25-.15Zm-1.61,0a.15.15,0,1,1,.21.2.15.15,0,0,1-.21,0h0A.14.14,0,0,1,391.73,433.31Zm-.76.81a.15.15,0,0,1,.21,0,.15.15,0,0,1,0,.21.14.14,0,0,1-.2,0h0A.15.15,0,0,1,391,434.12Zm1.51-1.63a.15.15,0,1,1,.2.21.17.17,0,0,1-.19,0A.15.15,0,0,1,392.48,432.49Zm-2.37.84a.15.15,0,0,1,.21,0,.14.14,0,0,1,0,.16.14.14,0,0,1-.19.09.15.15,0,0,1-.09-.19Zm.76-.82a.15.15,0,0,1,.21,0,.14.14,0,0,1,0,.16.14.14,0,0,1-.13.1.15.15,0,0,1-.14-.08A.15.15,0,0,1,390.87,432.51Zm.86-.86a.14.14,0,0,1,.14.09.14.14,0,0,1-.07.19.15.15,0,0,1-.2-.08.15.15,0,0,1,.08-.19Z",
                                                            "data-name":
                                                              "a8689329-7302-4e02-acc8-5711ba6f5e8e",
                                                            fill: "#231f20",
                                                            "fill-rule":
                                                              "evenodd"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "bd7c22b2-59a1-4c89-9ad8-eadcdf7ce316",
                                                      "data-name":
                                                        "b3249930-7a83-4623-84f5-35da2f4c018f"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "b9bf737a-93d5-4d26-abc0-ae2f05fef65d",
                                                        d:
                                                          "M386.37,413.2a.89.89,0,0,1,.28.07,1,1,0,0,1,.24.17.9.9,0,0,1,.28.5.23.23,0,0,0,.28.19.19.19,0,0,0,.1-.05.21.21,0,0,0,.08-.22,1.47,1.47,0,0,0-.13-.42,1.51,1.51,0,0,0-.65-.6,1.66,1.66,0,0,0-.42-.12.24.24,0,0,0-.26.21.22.22,0,0,0,.2.26",
                                                        "data-name":
                                                          "b3e8c324-6e8c-414c-9cb4-2567c8af2052",
                                                        fill: "#fff"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "b5adcbbb-ae6f-43fb-930c-54264dc7065d",
                                                        d:
                                                          "M386.6,412.31a1.89,1.89,0,0,1,1.44,1.34.24.24,0,1,0,.46-.12h0a2.38,2.38,0,0,0-1.81-1.69.23.23,0,0,0-.28.19.22.22,0,0,0,.18.27",
                                                        "data-name":
                                                          "b7aa70ac-38c2-4354-84e4-9f62dc74f038",
                                                        fill: "#fff"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "bf981939-6f20-4792-b1c3-1a32dd287f81",
                                                        d:
                                                          "M386.85,411.38a2.83,2.83,0,0,1,2.1,1.95.23.23,0,0,0,.17.16.23.23,0,0,0,.23-.07.2.2,0,0,0,0-.22,3.28,3.28,0,0,0-2.44-2.28.19.19,0,0,0-.18,0,.23.23,0,0,0-.1.15.2.2,0,0,0,0,.18.21.21,0,0,0,.15.1",
                                                        "data-name":
                                                          "b1ab9cea-c5fe-485d-a491-0ab092245c5e",
                                                        fill: "#fff"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "b6aa4eb1-6779-4df8-8149-b018bdfaf212",
                                                        d:
                                                          "M387.11,410.45a3.8,3.8,0,0,1,2.75,2.56.24.24,0,0,0,.45-.14,4.29,4.29,0,0,0-3.1-2.89.25.25,0,0,0-.28.18.25.25,0,0,0,.17.28",
                                                        "data-name":
                                                          "a21b9ea0-0734-4b57-a82f-13931a68e18c",
                                                        fill: "#fff"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "aa269d33-e9fb-4dcb-a9c5-b91bb7f83b63",
                                                        d:
                                                          "M386.45,416.4a.88.88,0,0,1,0,1.23L383,421.34a.87.87,0,0,1-1.22.06h0l-2.39-2.25a.86.86,0,0,1,0-1.23l3.48-3.71a.88.88,0,0,1,1.23-.06Z",
                                                        "data-name":
                                                          "b306577c-01b5-47a1-886b-4d2515bd6253",
                                                        fill: "#414042"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "a21bb65f-2398-41a3-9ad4-c0202cfef85c",
                                                        d:
                                                          "M379.94,419.61l-.51-.47a.85.85,0,0,1,0-1.2l1.15-1.24a1.23,1.23,0,0,0-.08.33c.06.36.41.58.84.8a1,1,0,0,1,.17.1Zm1.23,1.15,1.6-1.72a2,2,0,0,0-.49-.62,1.85,1.85,0,0,0-.66-.45L380,419.68Zm2.63-.65c-.37,0-.6-.39-.86-.8l-.11-.17-1.59,1.71.52.48a.84.84,0,0,0,1.19-.07L384.1,420A1.11,1.11,0,0,1,383.8,420.11Zm.73-5.38-.51-.47a.83.83,0,0,0-1.19.06l-1.14,1.21.3-.06a.91.91,0,0,1,.65.49l-.06.07c-.34-.51-.66-.72-1.44.11-1.31,1.41.25,1.32,1.23,2.24s1,2.47,2.29,1.07-.26-1.33-1.24-2.24a4.34,4.34,0,0,1-.56-.72Zm-.29,2.91.2.12c.44.23.79.42.83.8a.63.63,0,0,1,0,.27l1.12-1.2a.85.85,0,0,0,0-1.2l-.51-.47Zm.36-2.85-1.6,1.72a1.88,1.88,0,0,0,.5.62,1.84,1.84,0,0,0,.65.46l1.6-1.71Z",
                                                        "data-name":
                                                          "a4d56429-eef4-487a-bb6e-0ed6ba0a19fe",
                                                        fill:
                                                          "url(#f3ada2ee-8d89-49f4-acb2-295fd8685195)",
                                                        "fill-opacity": "0.5"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "b7191e0e-143e-4da1-bb63-6854250de976",
                                                        d:
                                                          "M381.4,416.21a.12.12,0,0,1,0,.16l-.08,0a.12.12,0,0,1-.11-.07.11.11,0,0,1,0-.13A.11.11,0,0,1,381.4,416.21Z",
                                                        "data-name":
                                                          "f3a583ac-07de-4cba-a3cf-c5352012be73",
                                                        fill: "#414042"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "ac2ccb16-7a76-442e-820e-cc19049127ee",
                                                      "data-name":
                                                        "beac5cee-725f-4972-aea0-4bf1975521ff"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M415.88,399.67l2.12-2.28,4.08,3.81L420,403.47Z",
                                                        fill: "#f26522"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M418.05,401.43a3.57,3.57,0,0,1-1.12-2.89,3.55,3.55,0,1,0,4.08,3.8A3.55,3.55,0,0,1,418.05,401.43Z",
                                                        fill: "#e52423"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M424.27,398l-.08-.08,0,0,0,0-.08.09h0l0,0,.08.08Zm.16-.17-.1-.09,0,0,0,.1-.09,0,0,0,.1.09h0l-.08-.08.09,0,0,0,0-.09.08.07Zm-1.53-1.58a3.55,3.55,0,0,1,.17,5,3.62,3.62,0,0,1-2.05,1.09,3.54,3.54,0,0,0-3.22-3.84,4.1,4.1,0,0,0-.86,0,3.55,3.55,0,0,1,3.84-3.24,3.61,3.61,0,0,1,2.12.94Z",
                                                        fill: "#f99f1c"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "bf24050f-8e8b-4ff1-bb4a-7d4cb0e5940d",
                                                      "data-name":
                                                        "bdd76c75-30ab-450a-8817-d33777e5e0fc"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "b21b2b1a-355e-4adc-99ca-362e5fcf4f66",
                                                        d:
                                                          "M400,402.15l11.51-12.35a10.37,10.37,0,0,0-2.11-.84,5.26,5.26,0,0,0-5.22,1.43l-5.92,6.35Z",
                                                        "data-name":
                                                          "af7681b7-a38b-4b3d-b55e-a5bfd8ea84aa",
                                                        fill:
                                                          "url(#fd45be08-0532-4df6-9430-fd5ec28854df)"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M399.44,379.05l9.36,2.29,5.55,5.18a5.06,5.06,0,0,1-3.65,1h-.07L400.27,385l2.31,7.11,1,3c.51,1.68-.08,3.31-1.59,4.93l-2,2.13-1.74-5.41-1.34-4.17-.31-1-2.27-7.06Z",
                                                        fill:
                                                          "url(#f07f3953-184e-435a-848a-c40a7437d639)"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          id:
                                                            "efe68158-0f77-44f4-b2ea-52fd2b035fa6",
                                                          "data-name":
                                                            "f4d35364-182a-41ba-b5f9-9180d620fe32"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "bde7df5e-b7d5-499f-ad09-64c4cef7ece1",
                                                            d:
                                                              "M399.44,379.05l9.36,2.29,5.55,5.18a5.06,5.06,0,0,1-3.65,1h-.07L400.29,385c-3.67-.85-4.79,3.25-3.7,6.63h0l-2.27-7.06Z",
                                                            "data-name":
                                                              "b046d88c-bcd8-49e6-bff8-e2bc95ff87ad"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            d:
                                                              "M399.44,379.05l9.36,2.29,5.55,5.18a5.06,5.06,0,0,1-3.65,1h-.07L400.29,385c-3.67-.85-4.79,3.25-3.7,6.63h0l-2.27-7.06Z",
                                                            fill: "#fff"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "e35e80f8-0b33-48f2-b018-3b2ebdd6070a",
                                                      "data-name":
                                                        "a97b5f9b-9170-49ee-94ea-bc090b80dade"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          id:
                                                            "bfe8a0c6-af21-477c-ad7e-6cb0f3bf6bf2",
                                                          "data-name":
                                                            "f987dd89-3c4e-4ce1-b60f-6bde008c457f"
                                                        }
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "ff5867ac-0c67-49b8-839c-fbba062947ca",
                                                            d:
                                                              "M386.91,403.94l1.6-1.71a1.88,1.88,0,0,0-.3-.12.71.71,0,0,0-.72.2l-.83.88Z",
                                                            "data-name":
                                                              "fba3064a-ac86-4d4f-82d0-3c40a06bae0a",
                                                            fill:
                                                              "url(#fa6a8c68-a8ac-405a-871c-8ee28576eeb6)"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("path", {
                                                          attrs: {
                                                            id:
                                                              "abe283e5-511a-4f42-949a-bd6111200247",
                                                            d:
                                                              "M386.43,402.48h0l.05.13h0l.18.58.25.75.27-.29a.7.7,0,0,0,.22-.69l-.13-.42-.32-1,1.44.36a.76.76,0,0,0,.67-.27l.27-.29-3.54-.87Z",
                                                            "data-name":
                                                              "f687ac6c-faf3-4f9c-85ce-63435629f58c",
                                                            fill:
                                                              "url(#e30f92aa-92fd-4e8e-90d8-f1b6d0fddb54)"
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "g",
                                                          {
                                                            attrs: {
                                                              id:
                                                                "baf3cbf5-9824-4309-8a35-0668d3b46892",
                                                              "data-name":
                                                                "e25a8dac-fea6-4d93-9c97-9696b85afe8b"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                id:
                                                                  "b45f5847-9538-46ed-9242-d3801c82bfd1",
                                                                d:
                                                                  "M386.43,402.48c-.15-.47,0-1.05.52-.93l1.44.36a.74.74,0,0,0,.67-.27l.28-.29-3.55-.87Z",
                                                                "data-name":
                                                                  "adb8bb06-20a3-4cc2-9e1e-72e04c644abd"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("path", {
                                                              attrs: {
                                                                id:
                                                                  "bae8fb81-3900-4c62-bca3-dffbeb1df26b",
                                                                d:
                                                                  "M386.43,402.48c-.15-.47,0-1.05.52-.93l1.44.36a.74.74,0,0,0,.67-.27l.28-.29-3.55-.87Z",
                                                                "data-name":
                                                                  "bcc896ef-11cd-480d-8939-94195778a7b3",
                                                                fill: "#fff"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M383.19,406.06l.05.71.58.54-.4.43-2.29-2.13.4-.43,1.17,1.08-.12-2.21.44-.47.14,1.9,2.19.16-.46.5Zm-7.06,6a1.55,1.55,0,0,0-.83,0,1.78,1.78,0,0,0-.74.49h0a1.69,1.69,0,0,0-.43.77,1.47,1.47,0,0,0,0,.83,1.68,1.68,0,0,0,1.2,1.12,1.53,1.53,0,0,0,.82-.05,1.79,1.79,0,0,0,.73-.48h0a1.8,1.8,0,0,0,.44-.77,1.56,1.56,0,0,0,0-.83,1.67,1.67,0,0,0-1.2-1.12Zm.66,1.31a.94.94,0,0,1,0,.55,1.12,1.12,0,0,1-.28.51h0a1.11,1.11,0,0,1-.48.31.94.94,0,0,1-.55,0,1.19,1.19,0,0,1-.83-.77,1.14,1.14,0,0,1,0-.55,1.18,1.18,0,0,1,.28-.5h0a1.08,1.08,0,0,1,.49-.32,1,1,0,0,1,.55,0A1.19,1.19,0,0,1,376.79,413.38Zm3.55-3.83a1,1,0,0,0,.05-.62,1,1,0,0,0-.32-.53,1.13,1.13,0,0,0-.55-.29,1.08,1.08,0,0,0-.59.07,1.76,1.76,0,0,0-.58.43l-.87.93,2.27,2.12.4-.43-1.92-1.79.46-.49a.88.88,0,0,1,.51-.31.64.64,0,0,1,.67.59v0a.85.85,0,0,1-.27.52l-.07.08.35.32L380,410l1.1.15.42-.45Z",
                                                        fill: "#fff"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        ref: "carouselTraveling",
                                        staticClass: "carousel__visual"
                                      },
                                      [
                                        _c("v-image", {
                                          attrs: {
                                            alt: _vm.$t(
                                              "cards.white.carousel.account.alt"
                                            ),
                                            "aspect-ratio": 380 / 380,
                                            tiny: {
                                              default: require("@/images/white/carousel/traveling.png"),
                                              retina: require("@/images/white/carousel/traveling@2.png")
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "svg",
                                          {
                                            ref: "travelingSVG",
                                            attrs: {
                                              id:
                                                "e142121c-1c2e-4253-a5c3-49f397677b9c",
                                              viewBox: "0 0 380 380",
                                              xmlns:
                                                "http://www.w3.org/2000/svg"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id:
                                                    "b44b8adb-1423-4943-963d-a7422fbee27a",
                                                  "data-name": "lines"
                                                }
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    id:
                                                      "eafb3920-c1e1-4797-b113-e5b9af76858a",
                                                    d:
                                                      "M263,110q59.58-16.27,89.07-23.6T370,94.17",
                                                    "data-name": "0",
                                                    fill: "none",
                                                    stroke: "#000",
                                                    "stroke-dasharray": "0 6",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    id:
                                                      "b0a8d9a8-7b48-4c9a-9e7f-72a8c5327acd",
                                                    d:
                                                      "M141.39,113.77Q190.32,97.92,263,110",
                                                    "data-name": "1",
                                                    fill: "none",
                                                    stroke: "#000",
                                                    "stroke-dasharray": "0 6",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    id:
                                                      "bb49da90-e6ca-4f29-9062-3366029bc061",
                                                    d:
                                                      "M49.34,169.64q43.13-40,92-55.87T263,108.89",
                                                    "data-name": "2",
                                                    fill: "none",
                                                    stroke: "#000",
                                                    "stroke-dasharray": "0 6",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    id:
                                                      "fde453cc-5846-4009-a99a-86694d73eaab",
                                                    d:
                                                      "M17.47,110.68Q-9.92,103.38,10.52,126C31,148.58,65,180.67,131.91,221.77q66.9,41.1,146.22,68.6",
                                                    "data-name": "3",
                                                    fill: "none",
                                                    stroke: "#000",
                                                    "stroke-dasharray": "0 6",
                                                    "stroke-linecap": "round",
                                                    "stroke-linejoin": "round",
                                                    "stroke-width": "2"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id:
                                                    "a1e5c684-3bad-48bb-a9ca-e6d0e443450a",
                                                  "data-name": "pins"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "a66a0993-95df-4d7e-b315-65c1052e9299",
                                                      "data-name": "0"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M49,44.5A39.5,39.5,0,1,1,9.5,84,39.49,39.49,0,0,1,49,44.5Z",
                                                        fill: "#fff",
                                                        "fill-rule": "evenodd",
                                                        stroke: "#000"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "a7f00ab7-fc96-4ee0-be86-d006e92c6b09",
                                                        d:
                                                          "M49,91.4v11.2m-4.17,0h8.34m-9-29.2h9.66M44,65H54V86l-5,5-5-5Zm6.08,12.4a.4.4,0,1,0,0,.8.4.4,0,1,0,0-.8m-3.16,3.7a.4.4,0,1,0,0,.8.4.4,0,1,0,0-.8m4.33,1.6a.4.4,0,1,0,.42.4.41.41,0,0,0-.42-.4",
                                                        "data-name":
                                                          "Champagne",
                                                        fill: "none",
                                                        stroke: "#000"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "b3048a49-008e-4def-be40-91bc27af7dd9",
                                                      "data-name": "1"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M278,243.5A39.5,39.5,0,1,1,238.5,283,39.49,39.49,0,0,1,278,243.5Z",
                                                        fill: "#fff",
                                                        "fill-rule": "evenodd",
                                                        stroke: "#000"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "a671f57c-0d3f-4051-9026-7d7a5ecd8561",
                                                        d:
                                                          "M267,277.21h24l-12.63,16.42Zm11.37,16.42v10.11m-5.05,0h10.1m-12.63-21.48h16.42m-8.84,10.11L286,272.16m1.26-6.88a3.29,3.29,0,1,1-3.29,3.29A3.29,3.29,0,0,1,287.21,265.28Zm1.29-.28,3-8",
                                                        "data-name": "Group-3",
                                                        fill: "none",
                                                        stroke: "#000"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "fcccc09c-d063-4c24-b65f-997af507b100",
                                                      "data-name": "2"
                                                    }
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        d:
                                                          "M263,70.5A39.5,39.5,0,1,1,223.5,110,39.49,39.49,0,0,1,263,70.5Z",
                                                        fill: "#fff",
                                                        "fill-rule": "evenodd",
                                                        stroke: "#000"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("path", {
                                                      attrs: {
                                                        id:
                                                          "f8052b5f-c0d0-472c-814c-e6c671bfbc62",
                                                        d:
                                                          "M248.82,94.05a2.23,2.23,0,0,0-.28,2.5,2.25,2.25,0,0,0,4.15-.4.75.75,0,0,1,.82-.55l3.84.55a.75.75,0,0,1,.65.79,6.75,6.75,0,1,1-11.76-5.17Zm2.79,3.43,2.64,4.84m-5.69-5.74-3.62,2m5-.9-1.4,4.75m.32-8.36,1.18-.57a3,3,0,0,0,1.66-3.2,1.4,1.4,0,0,0-2.23-.9l-3.19,2.39m2,25.2a9.25,9.25,0,0,1,9.38-8.72h1.92a1.54,1.54,0,0,0,1.26-.7,12,12,0,1,1,9.94,18.7h-13.5a9,9,0,0,1-9-9.28Zm9.17-4.22h4.86a1.47,1.47,0,0,0,1.39-1,7.5,7.5,0,1,1,7.08,10h-13.5a4.5,4.5,0,0,1-4.41-5.39A4.6,4.6,0,0,1,257.39,112.75Zm13.71-2.25a3.38,3.38,0,1,0,3.37,3.38A3.38,3.38,0,0,0,271.1,110.5Z",
                                                        "data-name": "Food",
                                                        fill: "none",
                                                        stroke: "#000"
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "a16cbe11-54be-458c-893b-b67ede611534",
                                                      "data-name": "3"
                                                    }
                                                  },
                                                  [
                                                    _c("circle", {
                                                      attrs: {
                                                        id:
                                                          "fd13fb93-ef90-4c58-a962-bc80cee5acfc",
                                                        cx: "48.43",
                                                        cy: "170.44",
                                                        "data-name":
                                                          "Oval-Copy-2",
                                                        fill: "#fff",
                                                        r: "6",
                                                        stroke: "#000",
                                                        "stroke-miterlimit":
                                                          "10"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("circle", {
                                                      attrs: {
                                                        id:
                                                          "a21ef01a-adc4-4859-85d4-c76718125833",
                                                        cx: "48.43",
                                                        cy: "170.44",
                                                        "data-name":
                                                          "Oval-Copy-4",
                                                        r: "3"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("circle", {
                                                      staticStyle: {
                                                        isolation: "isolate"
                                                      },
                                                      attrs: {
                                                        id:
                                                          "a460cf32-3a02-42d0-90af-fdaef5ba6b6a",
                                                        cx: "48.43",
                                                        cy: "170.44",
                                                        "data-name":
                                                          "Oval-Copy-3",
                                                        fill: "none",
                                                        opacity: "0.25",
                                                        r: "11",
                                                        stroke: "#000",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                        "stroke-width": "0.5"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("circle", {
                                                      staticStyle: {
                                                        isolation: "isolate"
                                                      },
                                                      attrs: {
                                                        id:
                                                          "ee65d020-6050-4a3a-a5aa-dc751e7a0b7f",
                                                        cx: "48.43",
                                                        cy: "170.44",
                                                        "data-name":
                                                          "Oval-Copy-5",
                                                        fill: "none",
                                                        opacity: "0.1",
                                                        r: "16",
                                                        stroke: "#000",
                                                        "stroke-linecap":
                                                          "round",
                                                        "stroke-linejoin":
                                                          "round",
                                                        "stroke-width": "0.5"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "carousel__right" }, [
                      _c(
                        "div",
                        { staticClass: "carousel__item" },
                        [
                          _vm._l(1, function(i) {
                            return [
                              _c(
                                "div",
                                {
                                  ref: "content",
                                  refInFor: true,
                                  staticClass: "carousel__content"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "carousel__content-inner" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "contentTrigger",
                                          refInFor: true,
                                          staticClass:
                                            "carousel__headline-wrapper"
                                        },
                                        [
                                          _c("v-typo", {
                                            staticClass: "carousel__headline",
                                            attrs: { variant: "h2" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "cards.white.carousel.account.headline"
                                                )
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-typo", {
                                        staticClass: "carousel__paragraph",
                                        attrs: { variant: "body-paragraph" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "cards.white.carousel.account.paragraph"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "carousel__content-image"
                                        },
                                        [
                                          _c("v-image", {
                                            attrs: {
                                              "aspect-ratio": 320 / 378,
                                              tiny: {
                                                default: require("@/images/white/carousel/static/account.png"),
                                                retina: require("@/images/white/carousel/static/account@2.png")
                                              },
                                              alt: "todo fill alt"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  ref: "content",
                                  refInFor: true,
                                  staticClass:
                                    "carousel__content carousel__content--europe"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "carousel__content-inner" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "contentTrigger",
                                          refInFor: true,
                                          staticClass:
                                            "carousel__headline-wrapper"
                                        },
                                        [
                                          _c("v-typo", {
                                            staticClass: "carousel__headline",
                                            attrs: { variant: "h2" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "cards.white.carousel.europe.headline"
                                                )
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-typo", {
                                        staticClass: "carousel__paragraph",
                                        attrs: { variant: "body-paragraph" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "cards.white.carousel.europe.paragraph"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "carousel__content-image  carousel__content-image--europe"
                                        },
                                        [
                                          _c("v-image", {
                                            attrs: {
                                              "aspect-ratio": 818 / 814,
                                              tiny: {
                                                default: require("@/images/white/carousel/static/europe.png"),
                                                retina: require("@/images/white/carousel/static/europe@2.png")
                                              },
                                              alt: "todo fill alt"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  ref: "content",
                                  refInFor: true,
                                  staticClass: "carousel__content"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "carousel__content-inner" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "contentTrigger",
                                          refInFor: true,
                                          staticClass:
                                            "carousel__headline-wrapper"
                                        },
                                        [
                                          _c("v-typo", {
                                            staticClass: "carousel__headline",
                                            attrs: { variant: "h2" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "cards.white.carousel.traveling.headline"
                                                )
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-typo", {
                                        staticClass: "carousel__paragraph",
                                        attrs: { variant: "body-paragraph" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "cards.white.carousel.traveling.paragraph"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "carousel__content-image"
                                        },
                                        [
                                          _c("v-image", {
                                            attrs: {
                                              "aspect-ratio": 266 / 266,
                                              tiny: {
                                                default: require("@/images/white/carousel/static/traveling.png"),
                                                retina: require("@/images/white/carousel/static/traveling@2.png")
                                              },
                                              alt: "todo fill alt"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }